
import { Loader, LogIn } from 'lucide-react';

import { PasswordField } from '@/components/form/password-field';
import { TextField } from '@/components/form/text-field';
import { StyledLink } from '@/components/styled-link';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';

import { useLoginPage } from '@/pages/unauthenticated/auth/login/form/hooks/use-login-page';
import { LoginFormValues } from '@/pages/unauthenticated/auth/login/form/form-schema';

export const LoginForm = ({
  code,
  redirectUri,
}: {
  code?: string;
  redirectUri?: string;
}) => {
  const { form, isLoading, onSubmit, isSuccess } = useLoginPage(
    code,
    redirectUri,
  );

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <TextField<LoginFormValues>
          tabIndex={0}
          form={form}
          disabled={isLoading}
          name="email"
          label="Email"
          autoComplete="email"
        />

        <PasswordField<LoginFormValues>
          tabIndex={0}
          form={form}
          disabled={isLoading}
          name="password"
          label="Password"
          rightLabel={
            <StyledLink tabIndex={1} href="/reset-password">
              Forgot password?
            </StyledLink>
          }
          autoComplete="current-password"
        />
        <Button
          tabIndex={0}
          disabled={isLoading || isSuccess}
          className="w-full"
          type="submit"
        >
          {isLoading || isSuccess ? (
            <Loader className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <LogIn className="mr-2 h-4 w-4" />
          )}
          Continue
        </Button>
      </form>
    </Form>
  );
};
